import { useAuth } from "../auth/context";
import { useState, useEffect } from "react";
import { Logo, LogoMobile, WideLogo } from "./Logo";
import { Link, NavLink } from "react-router-dom";
import { ActivityIcon } from "lucide-react";
//import { baseUrl } from "../api";
import type { User } from "../auth/types";
import buttonBackground from "../assets/button_background_blue.webp";
import defaultAvatar from "../assets/placeholder.webp";

interface HeaderProps {
  user: User | null; // Record<string, unknown> | null;
  avatar_path: string | null;
}

interface NavProps {
  isMobile: boolean;
  closeMenu?: () => void;
}

function ExternalNav({ isMobile, closeMenu }: NavProps) {
  const location = window.location.pathname;

  return (
    <>
      {isMobile ? (
        <>
          <NavLink
            to="/"
            className={`font_family_base detail_text ${
              location === "/"
                ? "header-border-mobile header_border_mobile_color"
                : ""
            }`}
            onClick={closeMenu}
          >
            Home
          </NavLink>
          <NavLink
            to="/about"
            className={`font_family_base detail_text ${
              location === "/about"
                ? "header-border-mobile header_border_mobile_color"
                : ""
            }`}
            onClick={closeMenu}
          >
            About Us
          </NavLink>
          <NavLink
            to="/contact"
            className={`font_family_base detail_text ${
              location === "/contact"
                ? "header-border-mobile header_border_mobile_color"
                : ""
            }`}
            onClick={closeMenu}
          >
            Contact Us
          </NavLink>
          <NavLink
            to="/support"
            className={`font_family_base detail_text ${
              location === "/support"
                ? "header-border-mobile header_border_mobile_color"
                : ""
            }`}
            onClick={closeMenu}
          >
            Support
          </NavLink>
        </>
      ) : (
        <>
          <NavLink
            to="/"
            className={`font_family_base text_1 ${
              location === "/" ? "header-border header_border_color" : ""
            }`}
          >
            Home
          </NavLink>
          <NavLink
            to="/about"
            className={`font_family_base text_1 ${
              location === "/about" ? "header-border header_border_color" : ""
            }`}
          >
            About Us
          </NavLink>
          <NavLink
            to="/contact"
            className={`font_family_base text_1 ${
              location === "/contact" ? "header-border header_border_color" : ""
            }`}
          >
            Contact Us
          </NavLink>
          <NavLink
            to="/support"
            className={`font_family_base text_1 ${
              location === "/support" ? "header-border header_border_color" : ""
            }`}
          >
            Support
          </NavLink>
        </>
      )}
    </>
  );
}

function InternalNav({ isMobile, closeMenu }: NavProps) {
  const location = window.location.pathname;
  const stateId = localStorage.getItem("state_id");
  const subscriptionName = (localStorage.getItem("subscription_name") || "").toLowerCase();
  const isPremium = stateId === "7" || stateId === "8" || subscriptionName.includes("premium");

  return (
    <>
      {isMobile ? (
        <>
          <NavLink
            to="/games"
            className={`font_family_base detail_text ${
              location === "/games"
                ? "header-border-mobile header_border_mobile_color"
                : ""
            }`}
            onClick={closeMenu}
          >
            Active Games
          </NavLink>
          {isPremium && (
            <NavLink
              to="/advantage"
              className={`font_family_base detail_text ${
                location === "/advantage"
                  ? "header-border-mobile header_border_mobile_color"
                  : ""
              }`}
              onClick={closeMenu}
            >
              Advantage Betting
            </NavLink>
          )}
          <NavLink
            to="/rule/create"
            className={`font_family_base detail_text ${
              location === "/rule/create"
                ? "header-border-mobile header_border_mobile_color"
                : ""
            }`}
            onClick={closeMenu}
          >
            Create Rule
          </NavLink>
          <NavLink
            to="/rules"
            className={`font_family_base detail_text ${
              location === "/rules"
                ? "header-border-mobile header_border_mobile_color"
                : ""
            }`}
            onClick={closeMenu}
          >
            My Rules
          </NavLink>
          <NavLink
            to="/contact"
            className={`font_family_base detail_text ${
              location === "/contact"
                ? "header-border-mobile header_border_mobile_color"
                : ""
            }`}
            onClick={closeMenu}
          >
            Contact Us
          </NavLink>
          <NavLink
            to="/help"
            className={`font_family_base detail_text ${
              location === "/help"
                ? "header-border-mobile header_border_mobile_color"
                : ""
            }`}
            onClick={closeMenu}
          >
            Help
          </NavLink>
        </>
      ) : (
        <>
          <NavLink
            to="/games"
            className={`font_family_base text_1 ${
              location === "/games" ? "header-border header_border_color" : ""
            }`}
          >
            Active Games
          </NavLink>
          {isPremium && (
            <NavLink
              to="/advantage"
              className={`font_family_base text_1 ${
                location === "/advantage" ? "header-border header_border_color" : ""
              }`}
            >
              Advantage Betting
            </NavLink>
          )}
          <NavLink
            to="/rule/create"
            className={`font_family_base text_1 ${
              location === "/rule/create"
                ? "header-border header_border_color"
                : ""
            }`}
          >
            Create Rule
          </NavLink>
          <NavLink
            to="/rules"
            className={`font_family_base text_1 ${
              location === "/rules" ? "header-border header_border_color" : ""
            }`}
          >
            My Rules
          </NavLink>
          <NavLink
            to="/contact"
            className={`font_family_base text_1 ${
              location === "/contact" ? "header-border header_border_color" : ""
            }`}
          >
            Contact Us
          </NavLink>
          <NavLink
            to="/help"
            className={`font_family_base text_1 ${
              location === "/help" ? "header-border header_border_color" : ""
            }`}
          >
            Help
          </NavLink>
        </>
      )}
    </>
  );
}

const handleSettings = () => {};

const DesktopHeader = ({ user, avatar_path }: HeaderProps) => {
  const location = window.location.pathname;
  const [imageLoaded, setImageLoaded] = useState(false);
  const [currentUsername, setCurrentUsername] = useState(
    localStorage.getItem("username") || "",
  );
  const [isScrolled, setIsScrolled] = useState(false);

  useEffect(() => {
    const handleStorageChange = () => {
      setCurrentUsername(localStorage.getItem("username") || "");
    };

    window.addEventListener("storage", handleStorageChange);
    return () => window.removeEventListener("storage", handleStorageChange);
  }, []);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 0);
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <nav
      // className="top-nav row background_1"
      className="top-nav row"
      style={{
        width: "calc(100% - 20px)",
        backgroundColor: isScrolled ? "rgba(0, 0, 0, 0.9)" : "transparent",
        transition: "background-color 0.3s ease",
      }}
    >
      <div className="logo_left text_spacer">
        <NavLink to="/">
          <Logo />

          <WideLogo />
        </NavLink>
      </div>
      <div className="nav-content">
        <div className="nav-links">
          {user ? (
            <InternalNav isMobile={false} />
          ) : (
            <ExternalNav isMobile={false} />
          )}
        </div>
      </div>
      <div
        className={`welcome_text ${user ? "" : ""}`}
        style={{ textAlign: "right" }}
      >
        {user ? (
          <Link
            to="/settings"
            className="font_family_base welcome_text_inner"
            style={{ textAlign: "right" }}
          >
            Welcome, {currentUsername.slice(0, 16)}
            {currentUsername.length > 16 ? "..." : ""}
            {!imageLoaded && (
              <div className="w-10 h-10 rounded-full bg-gray-200 animate-pulse left_spacer"></div>
            )}
            {localStorage.getItem("avatar_url") !== null && (
              <img
                className={`w-10 h-10 rounded-full object-cover left_spacer transition-opacity duration-300 ${
                  imageLoaded
                    ? "opacity-100"
                    : "opacity-0 absolute top-0 left-0"
                }`}
                style={{
                  height: 50,
                  width: 50,
                  minWidth: 50,
                  minHeight: 50,
                  borderRadius: "50%",
                  objectFit: "cover",
                  flexShrink: 0,
                }}
                src={avatar_path || localStorage.getItem("avatar_url") || ""}
                onLoad={() => setImageLoaded(true)}
                onError={(e) => {
                  (e.target as HTMLImageElement).src = defaultAvatar;
                }}
                alt="X"
              />
            )}
            {/* {{user?.avatar} === null ? (
              <img
                className={`w-10 h-10 rounded-full object-cover left_spacer transition-opacity duration-300 ${
                  imageLoaded
                    ? "opacity-100"
                    : "opacity-0 absolute top-0 left-0"
                }`}
                onLoad={() => setImageLoaded(true)}
                alt="Avatar"
              />
            ) : (
              <img
                className={`w-10 h-10 rounded-full object-cover left_spacer transition-opacity duration-300 ${
                  imageLoaded
                    ? "opacity-100"
                    : "opacity-0 absolute top-0 left-0"
                }`}
                src={baseUrl + user?.avatar}
                onLoad={() => setImageLoaded(true)}
                alt="Avatar"
              />
            )} */}
          </Link>
        ) : (
          <div className="login_buttons_inner">
            {/* <div className="background_2" style={{ borderRadius: "20px" }}> */}
            {location !== "/register" && (
              <Link
                to="/register"
                className="button-base button-3d font_family_base"
                style={{
                  marginTop: "5px",
                  marginBottom: "5px",
                  backgroundImage: `url(${buttonBackground})`,
                  backgroundSize: "cover",
                  backgroundPosition: "center",
                  color: "white",
                }}
              >
                Sign Up
              </Link>
            )}
            {location !== "/login" && (
              <Link
                to="/login"
                className="button-base button-3d font_family_base"
                style={{
                  marginTop: "5px",
                  marginBottom: "5px",
                  backgroundImage: `url(${buttonBackground})`,
                  backgroundSize: "cover",
                  backgroundPosition: "center",
                  color: "white",
                }}
              >
                Log In
              </Link>
            )}
            {/* </div> */}
          </div>
        )}
      </div>
    </nav>
  );
};

const MobileHeader = ({
  user,
  avatar_path,
}: //  avatar,
// handleLogout,
// handleSettings,
// avatar,
// avatarLoading,
HeaderProps) => {
  const [menuActive, setMenuActive] = useState(false);
  const [imageLoaded, setImageLoaded] = useState(false);
  const location = window.location.pathname;
  const [currentUsername, setCurrentUsername] = useState(
    localStorage.getItem("username") || "",
  );
  const [isScrolled, setIsScrolled] = useState(false);

  useEffect(() => {
    const handleStorageChange = () => {
      setCurrentUsername(localStorage.getItem("username") || "");
    };

    window.addEventListener("storage", handleStorageChange);
    return () => window.removeEventListener("storage", handleStorageChange);
  }, []);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 0);
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  function toggleActive() {
    setMenuActive((menuActive) => !menuActive);
  }

  function closeMenu() {
    setMenuActive(false);
  }

  return (
    <nav
      //      className="top-nav background_1"
      className="top-nav"
      style={{
        width: "calc(100% - 20px)",
        backgroundColor: isScrolled ? "rgba(0, 0, 0, 0.9)" : "transparent",
        transition: "background-color 0.3s ease",
      }}
    >
      {/* Overlay backdrop */}
      {menuActive && (
        <div
          onClick={closeMenu}
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundColor: "rgba(0, 0, 0, 0.5)",
            zIndex: 998,
          }}
        />
      )}
      {/* <div className=""> */}
      <div className="nav-content-mobile row">
        {/* <div className="row"> */}
        <div className="col4of10">
          <button
            className="hamburger"
            aria-label="Toggle menu"
            onClick={toggleActive}
          >
            <span className="bar"></span>
            <span className="bar"></span>
            <span className="bar"></span>
          </button>
          <div
            className={`nav-links ${menuActive ? "active" : ""}`}
            style={{ zIndex: 999 }}
          >
            {user ? (
              <InternalNav isMobile={true} closeMenu={closeMenu} />
            ) : (
              <ExternalNav isMobile={true} closeMenu={closeMenu} />
            )}
          </div>
          <div className="left_spacer_big">
            {/* <div className="top_buffer"> */}
            <NavLink to="/" className={`font_family_base `}>
              <LogoMobile />
            </NavLink>{" "}
            {/* </div> */}
          </div>
          {/* </div> */}
        </div>
        <div
          className={`col6of10 ${user ? "" : ""}`}
          style={{ textAlign: "right" }}
        >
          {user ? (
            <Link
              onClick={handleSettings}
              to="/settings"
              className="font_family_base welcome_text_inner"
              style={{ textAlign: "right" }}
            >
              Welcome, {currentUsername.slice(0, 16)}
              {currentUsername.length > 16 ? "..." : ""}
              {!imageLoaded && (
                <div className="w-10 h-10 rounded-full bg-gray-200 animate-pulse left_spacer"></div>
              )}
              {localStorage.getItem("avatar_url") !== null && (
                <img
                  className={`w-10 h-10 rounded-full object-cover left_spacer transition-opacity duration-300 ${
                    imageLoaded
                      ? "opacity-100"
                      : "opacity-0 absolute top-0 left-0"
                  }`}
                  style={{
                    height: 50,
                    width: 50,
                    minWidth: 50,
                    minHeight: 50,
                    borderRadius: "50%",
                    objectFit: "cover",
                    flexShrink: 0,
                  }}
                  src={avatar_path || localStorage.getItem("avatar_url") || ""}
                  onLoad={() => setImageLoaded(true)}
                  onError={(e) => {
                    (e.target as HTMLImageElement).src = defaultAvatar;
                  }}
                  alt="Avatar"
                />
              )}
              {/* {user?.avatar === null ? (
                <img
                  className={`w-10 h-10 rounded-full object-cover left_spacer transition-opacity duration-300 ${
                    imageLoaded
                      ? "opacity-100"
                      : "opacity-0 absolute top-0 left-0"
                  }`}
                  src={baseUrl + "/media/avatars/default.png"}
                  onLoad={() => setImageLoaded(true)}
                  alt="Avatar"
                />
              ) : (
                <img
                  className={`w-10 h-10 rounded-full object-cover left_spacer transition-opacity duration-300 ${
                    imageLoaded
                      ? "opacity-100"
                      : "opacity-0 absolute top-0 left-0"
                  }`}
                  src={baseUrl + user?.avatar}
                  onLoad={() => setImageLoaded(true)}
                  alt="Avatar"
                />
              )} */}
            </Link>
          ) : (
            <div className="mobile-login">
              {location !== "/register" && (
                <Link
                  to="/register"
                  className="button-base button-3d font_family_base"
                  style={{
                    backgroundImage: `url(${buttonBackground})`,
                    backgroundSize: "cover",
                    backgroundPosition: "center",
                    color: "white",
                  }}
                >
                  Sign Up
                </Link>
              )}
              {location !== "/login" && (
                <Link
                  to="/login"
                  className="button-base button-3d font_family_base"
                  style={{
                    backgroundImage: `url(${buttonBackground})`,
                    backgroundSize: "cover",
                    backgroundPosition: "center",
                    color: "white",
                  }}
                >
                  Log In
                </Link>
              )}
            </div>
          )}
        </div>
        {/* </div> */}
      </div>
      {/* <LoginButton /> */}
    </nav>
  );
};

// interface PageNavProps {}

export function PageNav({ avatar_path = "" }: { avatar_path?: string } = {}) {
  const { user, loading } = useAuth();

  let avatar_url = null;
  if (avatar_path && avatar_path.length !== 0) {
    avatar_url = avatar_path;
  }

  if (loading) {
    return <ActivityIcon />;
  }

  return (
    <>
      <div className="show-desktop" style={{ padding: "0 10px" }}>
        <DesktopHeader user={user} avatar_path={avatar_url} />
      </div>
      <div className="show-mobile" style={{ padding: "0 10px" }}>
        <MobileHeader user={user} avatar_path={avatar_url} />
      </div>
    </>
  );
}
